export default __webpack_public_path__ + "static/media/menu-history-l.c2deffb6.svg";